module.exports = __webpack_public_path__ + "img/Moulding_1200x800.a7657be1.png";